(function () {
  'use strict';

  var MAX_PRELOAD_ITEMS = 10;
  var THROTTLE_DELAY = 140;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function shouldSkipPreloading() {
    if (window.matchMedia) {
      try {
        var prefersReducedData = window.matchMedia('(prefers-reduced-data: reduce)');
        if (prefersReducedData && prefersReducedData.matches) {
          return true;
        }
      } catch (error) {
        // Ignore matchMedia errors and continue.
      }
    }

    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!connection) {
      return false;
    }

    if (connection.saveData) {
      return true;
    }

    var effectiveType = connection.effectiveType || '';
    return effectiveType.indexOf('2g') !== -1;
  }

  function getImageSource(wrapper) {
    var image = wrapper.querySelector('img');
    if (!image) {
      return '';
    }
    return image.currentSrc || image.src || image.getAttribute('src') || '';
  }

  function collectSources(section) {
    var wrappers = toArray(section.querySelectorAll('[data-product-single-media-wrapper]'));
    if (!wrappers.length) {
      return [];
    }

    var queue = [];
    for (var i = 0; i < wrappers.length; i += 1) {
      var wrapper = wrappers[i];
      if (!wrapper || !wrapper.classList || !wrapper.classList.contains('hide')) {
        continue;
      }

      if (
        wrapper.hasAttribute('data-product-media-type-video') ||
        wrapper.hasAttribute('data-product-media-type-external_video') ||
        wrapper.hasAttribute('data-product-media-type-model')
      ) {
        continue;
      }

      var src = getImageSource(wrapper);
      if (src) {
        queue.push(src);
      }

      if (queue.length >= MAX_PRELOAD_ITEMS) {
        break;
      }
    }

    return queue;
  }

  function preloadQueue(queue) {
    if (!queue.length) {
      return;
    }

    var seen = Object.create(null);
    var orderedQueue = queue.filter(function (src) {
      if (seen[src]) {
        return false;
      }
      seen[src] = true;
      return true;
    });

    var index = 0;

    function run() {
      if (index >= orderedQueue.length) {
        return;
      }

      var src = orderedQueue[index++];
      if (!src) {
        scheduleNext();
        return;
      }

      var preloader = new Image();
      preloader.decoding = 'async';
      preloader.loading = 'eager';
      if ('fetchPriority' in preloader) {
        preloader.fetchPriority = 'low';
      }
      preloader.src = src;
      preloader.onload = preloader.onerror = scheduleNext;
    }

    function scheduleNext() {
      if (index >= orderedQueue.length) {
        return;
      }

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 800 });
      } else {
        setTimeout(run, THROTTLE_DELAY);
      }
    }

    scheduleNext();
  }

  function hydrateProductSections() {
    if (shouldSkipPreloading()) {
      return;
    }

    var sections = document.querySelectorAll('[data-section-type="product"]');
    if (!sections.length) {
      return;
    }

    toArray(sections).forEach(function (section) {
      if (section.dataset.mediaPreloaderInitialized === 'true') {
        return;
      }
      section.dataset.mediaPreloaderInitialized = 'true';

      var queue = collectSources(section);
      if (queue.length) {
        preloadQueue(queue);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', hydrateProductSections);
  document.addEventListener('shopify:section:load', hydrateProductSections);
})();

